import { useState } from "react";
import PortalNav from "../components/PortalNav";
import { ChevronLeft, ChevronRight } from "lucide-react";

const CATEGORIES = {
  "Morning Ritual": "var(--gold)",
  "Nutrition": "#8B6B4C",
  "Movement": "#5C5148",
  "Identity Work": "#7A5063",
  "Rest": "var(--warm-gray)",
};

const DAY_TEMPLATE = [
  { time: "6:30 AM", cat: "Morning Ritual", act: "Sunrise breathwork & warm lemon water", loc: "The Solarium", desc: "Nervous-system priming with guided pranayama and a herbal aperitif." },
  { time: "8:00 AM", cat: "Nutrition", act: "Chef's nourishment plate", loc: "The Dining Room", desc: "Hormone-forward morning meal, curated to your intake profile." },
  { time: "10:00 AM", cat: "Identity Work", act: "1:1 guided coaching", loc: "The Study", desc: "Framework session with your Saviar guide. Journal + integration." },
  { time: "12:30 PM", cat: "Nutrition", act: "Midday nourishment", loc: "The Garden Terrace", desc: "Soft midday meal, sipped slowly. Herbal supplement schedule." },
  { time: "1:30 PM", cat: "Movement", act: "Somatic movement + Pilates", loc: "The Movement Room", desc: "Low-impact, restorative movement to release stored tension." },
  { time: "4:00 PM", cat: "Rest", act: "Afternoon slow hour", loc: "Your Suite", desc: "Rest, read, bathe. The pause is the practice." },
  { time: "6:30 PM", cat: "Nutrition", act: "Chef's evening plate", loc: "The Dining Room", desc: "Warm, nourishing evening meal. Optional wine pairing on Fridays." },
  { time: "8:30 PM", cat: "Rest", act: "Wind-down ritual", loc: "Your Suite", desc: "Herbal regimen, sleep tonic, silk & candlelight." },
];

export default function Schedule() {
  const [day, setDay] = useState(7);
  return (
    <div className="portal-body" data-testid="schedule-page">
      <header style={{ background: "var(--charcoal)", color: "var(--ivory)", padding: "28px 24px 32px" }}>
        <div className="container-x">
          <p className="eyebrow eyebrow-light">Daily Rhythm</p>
          <h1 style={{ fontFamily: "var(--serif)", fontWeight: 300, fontSize: "clamp(1.9rem, 4vw, 2.6rem)", margin: "10px 0" }}>Day {day} — Deep Reset</h1>
          <p style={{ color: "rgba(250,246,238,.55)", fontSize: ".95rem" }}>Every block is designed. Move through it softly.</p>
        </div>
      </header>

      <main className="container-x" style={{ padding: "32px 24px" }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 24 }} data-testid="day-toggle">
          <button
            onClick={() => setDay((d) => Math.max(1, d - 1))}
            className="btn btn-outline-dark"
            style={{ padding: "10px 16px" }}
            data-testid="day-prev"
          ><ChevronLeft size={16} /> Prev</button>
          <span style={{ fontFamily: "var(--serif)", fontSize: "1.3rem" }}>Day {day} of 21</span>
          <button
            onClick={() => setDay((d) => Math.min(21, d + 1))}
            className="btn btn-outline-dark"
            style={{ padding: "10px 16px" }}
            data-testid="day-next"
          >Next <ChevronRight size={16} /></button>
        </div>

        <div style={{ display: "grid", gap: 12 }}>
          {DAY_TEMPLATE.map((b, i) => (
            <div key={i} className="portal-card" style={{ padding: 24, display: "grid", gridTemplateColumns: "80px 1fr", gap: 20 }} data-testid={`schedule-block-${i}`}>
              <div>
                <div style={{ fontFamily: "var(--serif)", fontSize: "1.2rem", color: "var(--charcoal)" }}>{b.time.split(" ")[0]}</div>
                <div style={{ fontSize: ".68rem", letterSpacing: ".2em", color: "var(--warm-gray)" }}>{b.time.split(" ")[1]}</div>
              </div>
              <div>
                <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 8 }}>
                  <span style={{ width: 8, height: 8, borderRadius: "50%", background: CATEGORIES[b.cat] }} />
                  <span className="eyebrow" style={{ color: CATEGORIES[b.cat] }}>{b.cat}</span>
                </div>
                <h3 style={{ margin: "0 0 6px" }}>{b.act}</h3>
                <p style={{ fontSize: ".78rem", letterSpacing: ".2em", textTransform: "uppercase", color: "var(--warm-gray)", margin: "0 0 10px" }}>{b.loc}</p>
                <p className="body-sm" style={{ margin: 0 }}>{b.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </main>
      <PortalNav />
    </div>
  );
}
